/**
 * Created by baladewa on 10/27/16.
 */
'use strict';
(function () {
    angular
        .module('commons')
        .component('basicEditorComponent', {
            templateUrl: function($attrs){
                return $attrs.template;
            },
            controller: function ($timeout,$scope, applicationConstants, EventManagerService) {
                var vm = this, fileUploadData=null;
                vm.files = [];
                vm.selectedItem = {};
                vm.masterLists = {};
                vm.action = applicationConstants.EDITOR_STATUS.ADD;
                vm.hedarLabel = applicationConstants.EDITOR_STATUS.ADD;

                vm.submitSelected = function () {
                    submitForm();
                };

                vm.setDefaultValue = function (key) {
                  vm.selectedItem[key] = ' ';
                };

                vm.deleteSelected = function () {
                    vm.action = applicationConstants.EDITOR_STATUS.DELETE;
                };

                vm.saveSelected = function () {
                    vm.action = applicationConstants.EDITOR_STATUS.EDIT;
                };

                vm.clickOnButton = function(action) {
                	 vm.action = action;
                };

                vm.clickOnItem = function(flag){
                	vm.onItemClick({
           			 flag:flag
                    });
                }

                vm.setUploadFile = function(){
                    var filename = event.target.files[0];
                    fileUploadData = new FormData();
                    fileUploadData.append('fileMeta', filename);
                    $timeout(function () {
                        vm.selectedItem.file = filename;
                    });
                };

                vm.setUploadFiles = function($files) {
                    fileUploadData = new FormData();
                    for(var i=0; i < $files.length; i++) {
                        vm.files.push($files[i]);
                    }

                    angular.forEach(vm.files,function(file){
                        fileUploadData.append('files',file);
                    });

                    $timeout(function () {
                        vm.selectedItem.files = vm.files;
                    });
                };

                vm.resetUploadFiles = function() {
                    vm.files = [];
                    fileUploadData = new FormData();
                };

                vm.changeAny = function (event, flag, operation, selectedItems) {
                    var options = {
                        event: event,
                        flag: flag,
                        selectedItems: selectedItems,
                        operation: operation
                    };
                    if(!angular.isUndefined(operation)){
                        options.operation = operation;
                    }
                    if(!angular.isUndefined(selectedItems)){
                        options.selectedItems = selectedItems;
                    }
                    vm.onChangeField(options);
                };

                vm.setSingleDay = function (day) {
                    if (day.value==='all'){
                        angular.forEach(vm.masterLists.displayWeekdays, function(date){
                            if (date.editable){
                                date.selected = day.selected;
                            } else {
                            	date.selected = false;
                            }
                        });
                    }else{
                        var all=true;
                        for(var i=1;i<vm.masterLists.displayWeekdays.length;i++){
                            var date = vm.masterLists.displayWeekdays[i];
                            if(date.editable && !date.selected){
                                all = false;
                                break;
                            }
                        }
                        vm.masterLists.displayWeekdays[0].selected = all
                    }
                };

                function submitForm() {
                    if(vm.frmEditor.$valid){
                        var options = {
                            action:vm.action,
                            selectedItem: vm.selectedItem
                        };
                        if(fileUploadData!==null){
                            options.formFiles = fileUploadData;
                        }
                      console.log("submitForm", options);
                        vm.onSubmit(options);
                    }
                }

                vm.$onChanges = function (changeObj) {
                    vm.resetUploadFiles();
                    if(changeObj.selectedData && changeObj.selectedData &&
                        (changeObj.selectedData.currentValue !== changeObj.selectedData.previousValue)){
                            vm.selectedItem = changeObj.selectedData.currentValue;
                        $timeout(function () {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.MULTI_SELECT_VALUE_CHANGE);
                        },0);

                            if((!!vm.selectedItem && vm.selectedItem !==null) && vm.selectedItem[vm.primaryKey] === null){
                                $timeout(function(){
                                    vm.frmEditor.$setPristine();
                                    vm.frmEditor.$setUntouched();
                                },0);
                            }
                    }

                    if(changeObj.masterDataLists && changeObj.masterDataLists &&
                        (changeObj.masterDataLists.currentValue !== changeObj.masterDataLists.previousValue)){
                        $timeout(function () {
                            vm.masterLists = changeObj.masterDataLists.currentValue;
                        },0)
                    }

                    if(changeObj.mode && changeObj.mode &&
                        (changeObj.mode.currentValue !== changeObj.mode.previousValue)){
                        $timeout(function () {
                            vm.action = changeObj.mode.currentValue;
                            vm.headerLabel = changeObj.mode.currentValue;
                        },0)
                    }
                };
            },
            bindings: {
                primaryKey:'@',
                selectedData: '<',
                mode:'<',
                masterDataLists: '<',
                onSubmit: '&',
                onChangeField: '&',
                onItemClick : '&'
            }
        });
})();
